export default () => {
  const tagsfileUpload = document.getElementById('ttags_tag_uploaded_files_attributes_0_asset');

  if(tagsfileUpload){
    tagsfileUpload.classList.add('btn','btn-secondary')
  }
};